<script>
import { getFunctions, httpsCallable } from "firebase/functions";
import handyUploader from "handy-uploader/src/components/handyUploader";
import {
  getDoc,
  setDoc,
  doc,
  getFirestore,
  collection,
  addDoc,
  updateDoc,
} from "firebase/firestore";
import {
  getStorage,
  ref,
  uploadString,
  deleteObject,
  getDownloadURL,
} from "firebase/storage";
import { v4 as uuidv4 } from "uuid";
export default {
  name: "StrappVerify",

  components: {
    handyUploader,
    Loader: () => import("@/components/Loader.vue"),
  },

  data() {
    return {
      verifyDialog: false,
      POAAttachments: [],
      IDAttachments: [],
      selfieAttachments: [],
      terms: "false",
      credit: "false",
      socialLink: "",
      loading: false,
      PaysuccessDialog: false,
      AcceptsuccessDialog: false,
      POAloading: false,
      POASuccess: false,
      POAUrls: [],
      IDloading: false,
      IDSuccess: false,
      IDUrls: [],
      selfieLoading: false,
      selfieSuccess: false,
      selfieUrls: [],
      booking: {},
    };
  },
  computed: {
    formIsValid() {
      return (
        this.selfieSuccess &&
        this.IDSuccess &&
        this.POASuccess &&
        this.terms === "true" &&
        this.credit === "true"
      );
    },
  },
  watch: {
    POAAttachments: function (newAttachments) {
      console.log(newAttachments);
      this.uploadPOAAttachments(newAttachments);
    },
    IDAttachments: function (newAttachments) {
      console.log(newAttachments);
      this.uploadIDAttachments(newAttachments);
    },
    selfieAttachments: function (newAttachments) {
      console.log(newAttachments);
      this.uploadSelfieAttachments(newAttachments);
    },
  },

  methods: {
    back() {
      this.$router.push({
        name: `Booking`,
        params: { booking: this.booking },
      });
    },
    async uploadSelfieAttachments(newAttachments) {
      console.log("AM here");
      this.selfieLoading = true;
      const storage = getStorage();
      const fileNames = [];

      const photos = [];

      for (let i = 0; i < newAttachments.length; i++) {
        const file = newAttachments[i].file.base64;
        const fileName = `${Date.now()}_${newAttachments[i].file.name}`;
        console.log(fileName);
        fileNames.push(fileName);

        const storageRef = ref(
          storage,
          `users/${this.$store.state.user.id}/selfie/${fileName}`
        );

        console.log(storageRef);

        const snapshot = await uploadString(storageRef, file, "base64");
        const downloadURL = await getDownloadURL(snapshot.ref);

        photos.push({ src: downloadURL });

        console.log(downloadURL);
      }
      console.log(photos);
      this.selfieUrls = photos;
      this.selfieLoading = false;
      this.selfieSuccess = true;
    },
    async uploadIDAttachments(newAttachments) {
      console.log("AM here");
      this.IDloading = true;
      const storage = getStorage();
      const fileNames = [];

      const photos = [];

      for (let i = 0; i < newAttachments.length; i++) {
        const file = newAttachments[i].file.base64;
        const fileName = `${Date.now()}_${newAttachments[i].file.name}`;
        console.log(fileName);
        fileNames.push(fileName);

        // const deleteRef = ref(storage, `users/${this.$store.state.user.id}/ID`);

        // // Delete the file
        // deleteObject(deleteRef)
        //   .then(() => {
        //     console.log('File deleted successfully');
        //   })
        //   .catch((error) => {
        //     // Uh-oh, an error occurred!
        //   });

        const storageRef = ref(
          storage,
          `users/${this.$store.state.user.id}/IDimages/${fileName}`
        );

        console.log(storageRef);

        const snapshot = await uploadString(storageRef, file, "base64");
        const downloadURL = await getDownloadURL(snapshot.ref);

        photos.push({ src: downloadURL });

        console.log(downloadURL);
      }
      console.log(photos);
      this.IDUrls = photos;
      console.log("ID URLS", this.IDUrls);
      this.IDloading = false;
      this.IDSuccess = true;
    },

    async uploadPOAAttachments(newAttachments) {
      console.log("AM here");
      this.POAloading = true;
      const storage = getStorage();
      const fileNames = [];

      const photos = [];

      for (let i = 0; i < newAttachments.length; i++) {
        const file = newAttachments[i].file.base64;
        const fileName = `${Date.now()}_${newAttachments[i].file.name}`;
        console.log(fileName);
        fileNames.push(fileName);

        const storageRef = ref(
          storage,
          `users/${this.$store.state.user.id}/POA/${fileName}`
        );

        console.log(storageRef);

        const snapshot = await uploadString(storageRef, file, "base64");
        const downloadURL = await getDownloadURL(snapshot.ref);

        photos.push({ src: downloadURL });

        console.log(downloadURL);
      }
      console.log(photos);
      this.POAUrls = photos;
      this.POAloading = false;
      this.POASuccess = true;
    },
    async uploadFiles() {
      console.log("ID URLS", this.IDUrls);

      this.loading = true;

      const db = getFirestore();

      const userId = this.$store.state.user.id;

      const privateUsersRef = doc(db, "users", userId, "privateData", userId);
      await updateDoc(privateUsersRef, {
        poa: this.POAUrls,
        IDImages: this.IDUrls,
        selfie: this.selfieUrls,
        socialLink: this.socialLink,
        terms: this.terms,
        credit: this.credit,
      }).then(async () => {
        console.log("User Document successfully updated!");

        // get booking data
        const bookingRef = doc(db, "bookings", this.$route.params.id);
        const bookingSnap = await getDoc(bookingRef);
        this.booking = bookingSnap.data();

        const usersRef = doc(db, "users", userId);

        await updateDoc(usersRef, {
          manual_verification_received: true,
          verified: true,
        }).then(() => {
          console.log("User Document successfully updated!");
        });

        // get user from store and update manual_verification_received to true on that user then update the store with the new data
        const user = this.$store.state.user;
        user.manual_verification_received = true;
        this.$store.commit("setUser", user);

        // get If user is lender or borrowerer by matching the user id with the lender id or borrower id of the booking
        if (this.booking.lenderID === userId) {
          console.log("lender");
          const id = uuidv4();

          await setDoc(doc(db, "manual_verification", id), {
            id: id,
            userId: userId,
            firstName: this.$store.state.user.firstName,
            bookingId: this.$route.params.id,
            status: "pending",
            booking: this.booking,
            poa: this.POAUrls,
            IDImages: this.IDUrls,
            selfie: this.selfieUrls,
            socialLink: this.socialLink,
            uploadedAt: new Date(),
            todo: "User is lender so we need to check the verification and make sure the booking is awaiting-payemnt",
          }).then(() => {
            console.log("Private Document successfully updated!");
          });

          await this.$store
            .dispatch("updateBookingData", {
              id: this.booking.id,
              lender_manual_payreq_received: true,
              status: "awaiting-payment",
            })
            .then(() => {
              try {
                const addMessage = httpsCallable(
                  getFunctions(),
                  "bookingRequestAccepted"
                );
                addMessage({
                  id: this.$route.params.id,
                  borrowerName: this.booking.borrowerName,
                  borrowerID: this.booking.borrowerID,
                  itemName: this.booking.itemName,
                });
              } catch (error) {
                const errorMessage = error.message;
                alert(errorMessage);
              }
              this.loading = false;
              this.verifyDialog = false;
              this.AcceptsuccessDialog = true;
            });
        } else {
          console.log("borrower");

          const id = uuidv4();
          console.log(id);

          await setDoc(doc(db, "manual_verification", id), {
            id: id,
            userId: userId,
            firstName: this.$store.state.user.firstName,
            bookingId: this.$route.params.id,
            status: "pending",
            booking: this.booking,
            poa: this.POAUrls,
            IDImages: this.IDUrls,
            selfie: this.selfieUrls,
            socialLink: this.socialLink,
            uploadedAt: new Date(),
            todo: "User is borrowe so we need to check the verification and then create the pay email",
          }).then(() => {
            console.log("Private Document successfully updated!");
          });
          await this.$store
            .dispatch("updateBookingData", {
              id: this.booking.id,
              manual_verification_received: true,
            })
            .then(() => {
              try {
                const addMessage = httpsCallable(
                  getFunctions(),
                  "bookingRequestAcceptedVerifyPage"
                );
                addMessage({
                  bookingid: this.$route.params.id,
                });
              } catch (error) {
                const errorMessage = error.message;
                alert(errorMessage);
              }

              this.loading = false;
              this.verifyDialog = false;
              this.PaysuccessDialog = true;
            });
        }
      });
    },
  },
};
</script>
<template>
  <div>
    <v-dialog
      v-model="PaysuccessDialog"
      max-width="450px"
      persistent
      transition="dialog-bottom-transition"
    >
      <template>
        <v-card style="border-radius: 12px !important" class="text-center">
          <v-card-title class="text-center black--text">
            <p class="my-3 ml-auto mr-auto">Woohoo!</p>
          </v-card-title>
          <v-divider></v-divider>
          <div class="grid">
            <v-img
              size="small"
              width="300px"
              height="300px"
              :src="require('@/assets/svgs/celebrate-1.svg')"
            ></v-img>
          </div>
          <v-card-text class="my-2">
            We have recieved your Verification documents. You may now make a
            payment on the booking.
          </v-card-text>

          <v-card-actions class="mt-n9">
            <v-col>
              <v-row class="my-3">
                <v-btn
                  block
                  class="btn white--text"
                  style="border-radius: 8px !important"
                  color="accent"
                  @click="back()"
                >
                  Continue
                </v-btn>
              </v-row>
            </v-col>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      v-model="AcceptsuccessDialog"
      max-width="450px"
      persistent
      transition="dialog-bottom-transition"
    >
      <template>
        <v-card style="border-radius: 12px !important" class="text-center">
          <v-card-title class="text-center black--text">
            <p class="my-3 ml-auto mr-auto">Woohoo!</p>
          </v-card-title>
          <v-divider></v-divider>
          <div class="grid">
            <v-img
              size="small"
              width="300px"
              height="300px"
              :src="require('@/assets/svgs/celebrate-1.svg')"
            ></v-img>
          </div>
          <v-card-text class="my-2">
            The booking has been accepted and we have recieved your Verification
            documents. We will review this within the next 24 hours and you will
            receive an email once you are verified.
          </v-card-text>

          <v-card-actions class="mt-n9">
            <v-col>
              <v-row class="my-3">
                <v-btn
                  block
                  class="btn white--text"
                  style="border-radius: 8px !important"
                  color="accent"
                  @click="back()"
                >
                  Continue
                </v-btn>
              </v-row>
            </v-col>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <v-row class="grid">
      <v-col cols="11">
        <v-card style="border-radius: 12px !important" class="ma-5">
          <v-card-title class="text-center black--text">
            <v-icon @click="back()"> mdi-arrow-left </v-icon>
            <p class="my-3 ml-auto mr-auto app--text">
              Verify Yourself to <br class="hidden-md-and-up" />
              get Strapped in
              <img
                height="30px"
                style="margin-left: 10px; margin-bottom: -5px"
                :src="require('@/assets/svgs/rocket-4.svg')"
              />
            </p>
          </v-card-title>
          <v-divider></v-divider>

          <v-card-text>
            <v-container class="mt-n10">
              <v-row>
                <v-col cols="12">
                  <p style="font-size: small" class="mb-5">
                    <br />
                    Please submit no more than 2 files per upload box.
                    <small>*indicates required field</small>
                  </p>
                  <p><b>Upload proof of address below (max size: 5MB)</b>*</p>
                  <v-row>
                    <div v-if="POAloading">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                        size="24"
                      ></v-progress-circular>
                      Uploading...
                    </div>
                    <div class="ml-3" v-if="POASuccess">
                      <v-img
                        max-width="40px"
                        :src="require('@/assets/fontawesome/check-duotone.svg')"
                      ></v-img>
                      Uploaded
                    </div>
                    <handy-uploader
                      v-if="!POASuccess"
                      ref="uploader"
                      :documentAttachment.sync="POAAttachments"
                      :fileUploaderType="'simple'"
                      :maxFileSize="5000"
                      :imageCompressor="true"
                      :imageCompressLevel="0.3"
                      :maxFileCount="3"
                      :badgeCounter="true"
                      :thumb="true"
                      :changeFileName="true"
                      :addFileDescription="true"
                      :addFileTag="true"
                      :tags="['Tag 1', 'Tag 2', 'Tag 3', 'Tag 4']"
                      :btnColor="'#B22AF0'"
                      :cardType="'raised'"
                      class="my-6"
                    >
                    </handy-uploader>
                  </v-row>

                  <p class="mt-4">
                    <b
                      >Photo of Identity Document (front and back) (max size:
                      5MB)</b
                    >*
                  </p>

                  <v-row>
                    <div v-if="IDloading">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                        size="24"
                      ></v-progress-circular>
                      Uploading...
                    </div>
                    <div class="ml-3" v-if="IDSuccess">
                      <v-row>
                        <v-col>
                          <v-img
                            max-width="40px"
                            :src="
                              require('@/assets/fontawesome/check-duotone.svg')
                            "
                          ></v-img>
                          Uploaded
                        </v-col>
                      </v-row>
                    </div>
                    <handy-uploader
                      v-if="!IDSuccess"
                      ref="uploader"
                      :documentAttachment.sync="IDAttachments"
                      :fileUploaderType="'simple'"
                      :maxFileSize="5000"
                      :imageCompressor="true"
                      :imageCompressLevel="0.3"
                      :maxFileCount="3"
                      :badgeCounter="true"
                      :thumb="true"
                      :changeFileName="true"
                      :addFileDescription="true"
                      :addFileTag="true"
                      :tags="['Tag 1', 'Tag 2', 'Tag 3', 'Tag 4']"
                      :btnColor="'#B22AF0'"
                      :cardType="'raised'"
                      class="my-6"
                    >
                    </handy-uploader>
                  </v-row>
                  <p class="mt-4"><b>Current Selfie (max size: 5MB)</b>*</p>
                  <v-row>
                    <div v-if="selfieLoading">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                        size="24"
                      ></v-progress-circular>
                      Uploading...
                    </div>
                    <div class="ml-3" v-if="selfieSuccess">
                      <v-img
                        max-width="40px"
                        :src="require('@/assets/fontawesome/check-duotone.svg')"
                      ></v-img>
                      Uploaded
                    </div>
                    <handy-uploader
                      v-if="!selfieSuccess"
                      ref="uploader"
                      :documentAttachment.sync="selfieAttachments"
                      :fileUploaderType="'simple'"
                      :maxFileSize="5000"
                      :imageCompressor="true"
                      :imageCompressLevel="0.3"
                      :maxFileCount="3"
                      :badgeCounter="true"
                      :thumb="true"
                      :changeFileName="true"
                      :addFileDescription="true"
                      :addFileTag="true"
                      :tags="['Tag 1', 'Tag 2', 'Tag 3', 'Tag 4']"
                      :btnColor="'#B22AF0'"
                      :cardType="'raised'"
                      style="
                        border-radius: 12px;
                        .theme--light.v-btn {
                          color: white;
                        }
                      "
                      class="my-6 white--text"
                    >
                    </handy-uploader>
                  </v-row>
                  <p class="mt-4"><b>Social Media Profile</b></p>

                  <p class="body-2">
                    Share a link to a social media profile or personal portfolio
                    website. This speeds up verification and helps with identity
                    checks. You can click on the links below to get your profile
                    urls.
                  </p>

                  <v-row class="gd-flex justify-start mb-3">
                    <div class="d-flex justify-space-between ma-4">
                      <div class="mx-5">
                        <a target="_blank" href="https://linkedIn.com/in/">
                          <v-img
                            target="_blank"
                            :src="require('@/assets/logos/linkedin.png')"
                            width="36"
                            height="36"
                          />
                        </a>
                      </div>
                      <div class="mx-5">
                        <a target="_blank" href="https://facebook.com/profile"
                          ><v-img
                            :src="require('@/assets/logos/facebook.png')"
                            width="36"
                            height="36"
                        /></a>
                      </div>
                      <div class="mx-5">
                        <a target="_blank" href="https://instagram.com"
                          ><img
                            :src="require('@/assets/logos/instagram.png')"
                            width="36"
                            height="36"
                        /></a>
                      </div>
                    </div>
                  </v-row>

                  <v-row>
                    <v-col cols="12" sm="8">
                      <v-text-field
                        v-model="socialLink"
                        style="border-radius: 12px"
                        outlined
                        persistent-hint
                        name="name"
                        placeholder=""
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12">
                  <p class=""><b>Terms and Conditions</b>*</p>
                  <p class="caption">
                    You agree that you have read, understood and accept the
                    <a
                      rel="noopener"
                      target="_blank"
                      href="https://docs.google.com/document/d/13vJX5f5g1AR8i048H793tO16YlaZqJSt2qIthWxzJIs/edit"
                      >Terms and Conditions.</a
                    >
                  </p>
                  <v-checkbox
                    v-model="terms"
                    label="I have read and accept the Terms and Conditions."
                    color="primary"
                    value="true"
                    hide-details
                  >
                    <a
                      href="https://docs.google.com/document/d/13vJX5f5g1AR8i048H793tO16YlaZqJSt2qIthWxzJIs/edit"
                    >
                      I have read and accept the Terms and Conditions
                    </a>
                  </v-checkbox>
                </v-col>
                <v-col cols="12">
                  <p class=""><b>Credit Check </b>*</p>
                  <p class="caption">
                    By selecting "I Accept" below, you agree and allow Strapp at
                    all times to:<br />
                    Contact, request and obtain information from any credit
                    provider (or potential credit provider) or registered credit
                    bureau that may be necessary to assess my/our behavior,
                    profile, payment patterns, indebtedness, whereabouts, and
                    creditworthiness;
                  </p>
                  <v-checkbox
                    v-model="credit"
                    value="true"
                    label="I Accept."
                    color="primary"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>
          <div style="display: flex; justify-content: center">
            <!-- <v-overlay style="z-index: 9" v-if="loading">
              <v-img :src="require('@/assets/svgs/copy2.svg')" />
              Compiling documents...
            </v-overlay> -->
            <v-btn
              elevation="8"
              :width="$vuetify.breakpoint.mdAndUp ? '7rem' : '5rem'"
              color="primary"
              class="ebtn ma-3"
              type="submit"
              :loading="loading"
              :disabled="!formIsValid"
              @click="uploadFiles()"
              >Submit</v-btn
            >
          </div>
        </v-card>
      </v-col>
    </v-row>
    <!-- <v-card v-if="loading" class="grid">
      <div>
        <Loader></Loader>
        Uploading documents...
      </div>
      <v-card-actions>
        <v-btn
          block
          class="btn white--text"
          style="border-radius: 8px !important"
          @click="loading = false"
          color="accent"
        >
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card> -->
  </div>
</template>

<style scoped>
.round {
  border-radius: 12px !important;
}

.theme--light.v-btn {
  color: white;
}
</style>
